import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_EXTERNAL_AUDIT_HISTORY = "GET_EXTERNAL_AUDIT_HISTORY";
export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetExternalAuditHistory/${data.eaAuditId}/${data.userTaskId}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};
const mockData = () => {
  return [];
};
const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};
register(GET_EXTERNAL_AUDIT_HISTORY, service, mock);